import Vue from "vue";
import { mapGetters } from "vuex";
import { ResourceLibrarySideMenu } from "@/components/SubMenus";
import { LoadingSpinner, PaginationText } from "@/components";
import { ListLayout } from "@/components/layouts";
import { paginationMixin } from "@/components/mixins";
import { ErrorLogService } from "@/services/ErrorLogService";
import { ResourceLibraryService } from "@/services/ResourceLibraryService";
import { stringHelper } from "@/components/mixins/stringHelper";
import { MediaService } from "@/services/";
import { controlsHelper } from "@/components/mixins/commonControlsHelper";
import {constants}           from "@/const" ;


export default Vue.extend({
  name: "ResourceLibrary",
  components: {
    ResourceLibrarySideMenu,
    LoadingSpinner,
    ListLayout,
    PaginationText
  },
  mixins: [paginationMixin, stringHelper, controlsHelper],
  props: {
    resourceLabelId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    searchInput: '',
    searchText: '',
    resourceLibraryLoading: true,
    searchResults: [],
    allResults: [], 
    uniqueMediaCategories: [],
    selectedCategories: [],
    categorySearchInput: '',
    showCategoryDropdown: false,
    selectedResultsPerPage: 10,
    currentPageNumber: 1,
    resultsPerPage: constants.RESULTS_PER_PAGE
  }),
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "activeAccountId",
      "McfCostCenterId",
      "audienceIds"
    ]),
    paginatedResults() {
      const start = (this.currentPageNumber - 1) * this.selectedResultsPerPage;
      const end = start + this.selectedResultsPerPage;
      return this.searchResults.slice(start, end);
    },
    filteredCategories() {
      if (!this.categorySearchInput.trim()) {
        return this.uniqueMediaCategories;
      }
      const searchLower = this.categorySearchInput.toLowerCase();
      return this.uniqueMediaCategories.filter((category: string) =>
        category.toLowerCase().includes(searchLower)
      );
    }
  },
  created() {
    this.loadResourceLibrary();
  },
  methods: {
    closeCategoryDropdown() {
      this.showCategoryDropdown = false;
    },
    openCategoryDropdown(){
      this.showCategoryDropdown = true;
    },
    onInputBlur() {
      // Small timeout to allow click event to fire on dropdown items
      setTimeout(() => {
        this.showCategoryDropdown = false;
      }, 200);
    },
    getUniqueMediaCategories() {
      // Use allResults to get all possible categories
      const categories = this.allResults
        .flatMap((item: any) => Array.isArray(item.MediaLabel) ? item.MediaLabel : [])
        .filter((category: string | undefined) => !!category)
        .sort((a: string, b: string) => a.localeCompare(b));
      this.uniqueMediaCategories = Array.from(new Set(categories));
    },
    selectCategory(category: string) {
      if (!this.selectedCategories.includes(category)) {
        this.selectedCategories.push(category);
        this.categorySearchInput = '';
        this.showCategoryDropdown = false;
        this.currentPageNumber = 1; // Reset to first page
        this.filterResultsByCategories();
      }
      else{
        this.removeCategory(category);
        this.showCategoryDropdown = false;
      }
    },

    removeCategory(category: string) {
      this.selectedCategories = this.selectedCategories.filter(c => c !== category);
      this.currentPageNumber = 1; // Reset to first page
      this.filterResultsByCategories();
    },

    onCategorySearchInput() {
      this.showCategoryDropdown = true;
    },

    isCategorySelected(category: string): boolean {
      return this.selectedCategories.includes(category);
    },

    filterResultsByCategories() {
      if (this.selectedCategories.length === 0) {
        this.searchResults = this.allResults;
      } else {
        this.searchResults = this.allResults.filter((item: any) =>
          Array.isArray(item.MediaLabel) &&
          this.selectedCategories.some(selectedCategory => item.MediaLabel.includes(selectedCategory))
        );
      }
    },

    downloadLink(fileId) {
      return MediaService.getMediaUrl(fileId);
    },

    onSearch() {
      this.loadResourceLibrary(this.searchInput);
    },
    loadResourceLibrary: function (searchTerm = "") {
      this.resourceLibraryLoading = true
      var params = {
        CostCenterId: this.McfCostCenterId,
        AccountId: this.activeAccountId,
        UserId: this.user?.UserId,
        UserAudiences: this.audienceIds,
        SearchTerm: searchTerm
      }

      return ResourceLibraryService.DocumentSearch(params)
        .then(results => {
          this.allResults = results;
          this.searchResults = results;
          this.filterResultsByCategories();
          this.getUniqueMediaCategories();
          this.searchText = searchTerm;
          return results;
        })
        .catch(err => {
          ErrorLogService.LogException(err);
          return [];
        })
        .finally(() => {
          this.resourceLibraryLoading = false
        })
    },
    resultsPerPageSelected(){ 
        this.currentPageNumber = 1; // Reset to first page when changing page size
        this.$emit("resultsPerPageChanged", this.selectedResultsPerPage)
        this.loadResourceLibrary(this.searchInput);
      },
    performNextPageResourceSearch() {
        this.resourceLibraryLoading = true;
        this.loadResourceLibrary(this.searchInput);
      },
      goToPage(pageNumber: number) {
  this.currentPageNumber = pageNumber;
},

nextPage() {
  if (this.currentPageNumber < this.totalPages) {
    this.currentPageNumber++;
  }
},

previousPage() {
  if (this.currentPageNumber > 1) {
    this.currentPageNumber--;
  }
}
  }
});